import {ModuleRouteManifest} from '../types'

export const surveyFeedbackRouteManifest: ModuleRouteManifest = {
  code: 'survey-feedback',
  privateRoutes: [
    'survey-feedback',
    'addupdatesurvey',
    'surveyresult',
    'surveyresultmanagement',
    'surveyresultgeneral',
    'surveyresultsemester',
    'surveyresultlecturer',
    'answer/*',
    'answerquestionitem/*',
    'survey/*',
    'surveyapplication/*',
    'surveyfrequency/*',
    'surveyquestion/*',
    'surveyquestiontype/*',
    'surveyquestiontypeanswer/*',
    'surveytype/*',
  ],
}
